import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { FeatureFlags } from '../../core/models/feature-flags.model';

/**
 * Feature Flags Service Actions
 *
 * Actions dispatched by FeatureFlagsService during LaunchDarkly lifecycle
 */
export const FeatureFlagsServiceActions = createActionGroup({
  source: 'FeatureFlags Service',
  events: {
    /**
     * Dispatched when FeatureFlagsService.initialize() is called
     * Marks the beginning of LaunchDarkly initialization
     */
    Init: emptyProps(),

    /**
     * Dispatched when LaunchDarkly client is ready
     * Triggers loading of initial flag values
     */
    Ready: emptyProps(),

    /**
     * Dispatched when LaunchDarkly initialization fails
     * Includes error message for debugging
     */
    'Init Failed': props<{ error: string }>(),

    /**
     * Dispatched when a single feature flag value changes
     * Used for real-time updates from LaunchDarkly change events
     */
    'Update Flag': props<{
      key: string;
      domain: string;
      property: string;
      value: unknown;
    }>(),

    /**
     * Dispatched to update all flags at once (batch operation)
     * Used during initialization to set all flag values efficiently
     */
    'Bulk Update': props<{ flags: FeatureFlags }>(),
  },
});

/**
 * Feature Flags Fallback Actions
 *
 * Actions for loading flags from static configuration
 */
export const FeatureFlagsFallbackActions = createActionGroup({
  source: 'FeatureFlags Fallback',
  events: {
    /**
     * Load feature flags from default values
     * Used when LaunchDarkly is disabled or unavailable
     */
    'Load From Defaults': props<{ flags: FeatureFlags }>(),
  },
});
